//upload channel picture
export const UPLOAD_CHANNEL_PICTURE_REQUEST = "UPLOAD_CHANNEL_PICTURE_REQUEST";
export const UPLOAD_CHANNEL_PICTURE_RECEIVE = "UPLOAD_CHANNEL_PICTURE_RECEIVE";
export const UPLOAD_CHANNEL_PICTURE_FAILURE = "UPLOAD_CHANNEL_PICTURE_FAILURE";
export const RESET_UPLOAD_CHANNEL_PICTURE= "RESET_UPLOAD_CHANNEL_PICTURE";

//upload profile picture
export const UPLOAD_BROADCAST_PROFILE_PICTURE_REQUEST = "UPLOAD_BROADCAST_PROFILE_PICTURE_REQUEST";
export const UPLOAD_BROADCAST_PROFILE_PICTURE_RECEIVE = "UPLOAD_BROADCAST_PROFILE_PICTURE_RECEIVE";
export const UPLOAD_BROADCAST_PROFILE_PICTURE_FAILURE = "UPLOAD_BROADCAST_PROFILE_PICTURE_FAILURE";
export const RESET_UPLOAD_BROADCAST_PROFILE_PICTURE= "RESET_UPLOAD_BROADCAST_PROFILE_PICTURE";

//create broadcaster profile
export const CREATE_BROADCASTER_PROFILE_REQUEST = "CREATE_BROADCASTER_PROFILE_REQUEST";
export const CREATE_BROADCASTER_PROFILE_RECEIVE = "CREATE_BROADCASTER_PROFILE_RECEIVE";
export const CREATE_BROADCASTER_PROFILE_FAILURE = "CREATE_BROADCASTER_PROFILE_FAILURE";
export const RESET_CREATE_BROADCASTER_PROFILE= "RESET_CREATE_BROADCASTER_PROFILE";

//update broadcaster profile
export const UPDATE_BROADCASTER_PROFILE_REQUEST = "UPDATE_BROADCASTER_PROFILE_REQUEST";
export const UPDATE_BROADCASTER_PROFILE_RECEIVE = "UPDATE_BROADCASTER_PROFILE_RECEIVE";
export const UPDATE_BROADCASTER_PROFILE_FAILURE = "UPDATE_BROADCASTER_PROFILE_FAILURE";
export const RESET_UPDATE_BROADCASTER_PROFILE= "RESET_UPDATE_BROADCASTER_PROFILE";

//update promocode
export const UPDATE_PROMOCODE_REQUEST = "UPDATE_PROMOCODE_REQUEST";
export const UPDATE_PROMOCODE_RECEIVE = "UPDATE_PROMOCODE_RECEIVE";
export const UPDATE_PROMOCODE_FAILURE = "UPDATE_PROMOCODE_FAILURE";
export const RESET_UPDATE_PROMOCODE = "RESET_UPDATE_PROMOCODE";